import React from 'react'
import PropTypes from 'prop-types'
import {Icon} from '@chakra-ui/react'

const OvalIcon = ({secondaryColor, ...props}) => {
    return (
        <Icon viewBox="0 0 40 40" fill="none" aria-hidden="true" {...props}>
            <path
                d="M19.9997 38.0622C29.9752 38.0622 38.0619 29.9755 38.0619 20C38.0619 10.0245 29.9752 1.93781 19.9997 1.93781C10.0242 1.93781 1.9375 10.0245 1.9375 20C1.9375 29.9755 10.0242 38.0622 19.9997 38.0622Z"
                fill={secondaryColor || 'currentColor'}
            />
            <path
                d="M20 38.9906C9.52468 38.9906 1 30.4659 1 20C1 9.53406 9.52468 1 20 1C30.4753 1 39 9.52468 39 20C39 30.4753 30.4753 39 20 39V38.9906ZM20 2.87562C10.5563 2.87562 2.87562 10.5563 2.87562 20C2.87562 29.4437 10.5563 37.1244 20 37.1244C29.4437 37.1244 37.1244 29.4437 37.1244 20C37.1244 10.5563 29.4344 2.87562 20 2.87562Z"
                fill="currentColor"
            />
        </Icon>
    )
}

OvalIcon.propTypes = {
    secondaryColor: PropTypes.string,
}

export default OvalIcon
